import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const InstantBookingLabelCircledIcon = forwardRef(
  ({ size = 40, className = '', ...props }, ref) => (
    <svg
      {...props}
      className={className}
      ref={ref}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill={Colors.tertiary} />
      <path
        d="M20.6543 17.0685L20.5141 17.5904L20.9648 17.8886L26.4007 21.4853L17.3096 30.508L19.3454 22.9315L19.4856 22.4096L19.0349 22.1114L13.599 18.5147L22.69 9.49197L20.6543 17.0685Z"
        stroke={Colors.dark}
        strokeWidth="1.5"
      />
    </svg>
  )
);

InstantBookingLabelCircledIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
};

export default InstantBookingLabelCircledIcon;
